export default __webpack_public_path__ + "static/media/user-icon.bbc38db3.svg";